webpackJsonp([267892159731516],{

/***/ 934:
/***/ (function(module, exports) {

	module.exports = {"pressInquiries":"Fyrirspurnir frá fjölmiðlum","pressText":"Hafðu samband við","logoTitle":"Skákgreind (SciChess) Logo","logoInfo":"SciChess og OcuChess eru skráð vörumerki. Það er ekki leyfilegt að nota SciChess lógóið nema með samþykki frá scichess.com og jafnvel þá einungis með því að nefna einnig scichess.com. Ekki er leyfilegt að blanda lógói Scichess saman við önnur lógó.","downloadLogo":"Sækja myndi í fullu upplausn","inTheNews":"SciChess í fréttunum"}

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	var _reactstrap = __webpack_require__(9);
	
	var _sidebar = __webpack_require__(21);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _reactYoutube = __webpack_require__(144);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var content = props.content;
	
	  return _react2.default.createElement(
	    _reactstrap.Container,
	    null,
	    _react2.default.createElement(
	      _sidebar2.default,
	      null,
	      _react2.default.createElement(
	        'h3',
	        { className: 'mb-4' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newsroom' })
	      ),
	      _react2.default.createElement(
	        _reactstrap.Row,
	        { className: 'videos-area my-3' },
	        _react2.default.createElement(
	          _reactstrap.Col,
	          { sm: '12', md: '6' },
	          _react2.default.createElement(_reactYoutube2.default, { videoId: 'oEYkgUuBSE0', className: 'w-100' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'my-5' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          content.pressInquiries
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          content.pressText,
	          ': ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:press@scichess.com' },
	            'press@scichess.com'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'my-5' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          content.logoTitle
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          content.logoInfo
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '', className: 'btn btn-warning mt-4' },
	          content.downloadLogo
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'my-5' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          content.inTheNews
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'stayTuned' })
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _newsroomLayout = __webpack_require__(156);
	
	var _newsroomLayout2 = _interopRequireDefault(_newsroomLayout);
	
	var _newsroom = __webpack_require__(934);
	
	var _newsroom2 = _interopRequireDefault(_newsroom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Sk\xE1kgreind | Fr\xE9ttir'
	      )
	    ),
	    _react2.default.createElement(_newsroomLayout2.default, _extends({ content: _newsroom2.default }, props))
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-newsroom-index-is-js-e21099f21b7b163f55af.js